import React from 'react';
import FiltersComponentBuilder from './filters-component-builder';

interface Filter {
  key: string;
  values?: { value: string; count: number }[];
  min?: number;
  max?: number;
}

interface FiltersProps {
  primaryColor: string;
  countColor: string;
  filters: Filter[];
  availableFilters?: string[];
  appliedFilters: Record<string, string[] | { from: number; to: number }>;
  onFilterChange: (
    key: string,
    value: string[] | { from: number; to: number },
  ) => void;
  currency?: string;
  language?: string;
  locale?: string;
}

const Filters: React.FC<FiltersProps> = ({
  availableFilters,
  primaryColor,
  countColor,
  filters,
  appliedFilters,
  onFilterChange,
  currency,
  language,
  locale,
}) => {
  // Create a map of filters for easier lookup
  const filtersMap = new Map(filters.map((filter) => [filter.key, filter]));

  // If availableFilters is provided, use it to order the filters
  const orderedFilters = availableFilters
    ? availableFilters
        .map((key) => filtersMap.get(key))
        .filter((filter): filter is Filter => !!filter)
    : filters;

  // Transform the filters into the format expected by FiltersComponentBuilder
  const formattedFilters = orderedFilters.reduce((acc, filter) => {
    if (filter.key === 'price') {
      acc[filter.key] = {
        min: filter.min,
        max: filter.max,
        value: appliedFilters[filter.key] || {
          from: filter.min || 0,
          to: filter.max || 0,
        },
      };
    } else {
      acc[filter.key] = {
        options: filter.values || [],
        value: (appliedFilters[filter.key] as string[]) || [],
      };
    }
    return acc;
  }, {} as Record<string, any>);

  return (
    <div className="filters-container">
      <FiltersComponentBuilder
        appliedFilters={appliedFilters}
        filters={formattedFilters}
        onChange={onFilterChange}
        primaryColor={primaryColor}
        countColor={countColor}
        minInitialPrice={
          filters.find((filter) => filter.key === 'price')?.min || null
        }
        maxInitialPrice={
          filters.find((filter) => filter.key === 'price')?.max || null
        }
        currency={currency}
        language={language}
        locale={locale}
      />
    </div>
  );
};

export default Filters;
